var generateComponentTheme = function generateComponentTheme(_ref) {
  var breakpoints = _ref.breakpoints,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium),
    menuButtonFontSize: typography.fontSizeLarge,
    menuButtonColor: colors.contrasts.grey125125,
    menuButtonHoverOpacity: '0.6'
  };
};
export default generateComponentTheme;